module.exports = {
      id: "face-frown-icon-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#face-frown-icon",
      toString: function () {
        return this.url;
      }
    }